import type React from 'react';
import { createContext, useContext, useState } from 'react';
import type { FieldValues } from '@zillow/cosmos';

type CosmosValuesContextType = {
  cosmosValues: FieldValues | null;
  setCosmosValues: (values: FieldValues) => void;
};

const CosmosValuesContext = createContext<CosmosValuesContextType | undefined>(undefined);

export function CosmosValuesProvider({ children }: { children: React.ReactNode }) {
  const [cosmosValues, setCosmosValues] = useState<FieldValues | null>(null);

  return (
    <CosmosValuesContext.Provider value={{ cosmosValues, setCosmosValues }}>{children}</CosmosValuesContext.Provider>
  );
}

export function useCosmosValues() {
  const context = useContext(CosmosValuesContext);
  if (context === undefined) {
    throw new Error('useCosmosValues must be used within a CosmosValuesProvider');
  }
  return context;
}
